export default {
  tokeninvalidation: "Token invalid, please log in again",
  networkexception: "Network abnormality",
  systemloadminute: "System load for 1 minute",
  systemloadfiveminute: "System load for 5 minute",
  systemloadquarterminute: "System load for 15 minute",
  malfunction: "In the midst of a malfunction",
  electricitylevel: "Electricity level",
  charging: "Charging in progress",
  cleanwatertank: "clean water",
  bilgetank: "sewage",
  nothave: "nothing",
  positioningsuccessful: "Localization successful",
  generalpositioning: "General positioning",
  positioningfailed: "seek failed",
  imuinitialization: "IMU initialization in progress",
  laserinitialization: "Laser initialization in progress",
  autonomousdriving: "Autonomous driving",
  mapsloading: "·",
  datarequestfailed: "Data request failed, please try again",
  CPUusagerate: "CPU usage rate",
  physicalusagerate: "Physical memory utilization rate",
  recordbag: "Record Bag",
  recording: "Recording in progress",
  recorded: "Record successful",
  recordfailed: "Recording failed, please try again",
  networkwrite: "Network Writing (KB/s)",
  networkread: "Online reading (KB/s)",
  diskwrite: "Disk write (KB/s)",
  diskread: "Disk read (KB/s)",
  restart: "restart",
  speed: "speed",
  rollingbrushpressure: "Rolling brush pressure",
  rollingbrushspeed: "Rolling brush speed",
  edgebrushspeed: "Edge brush speed",
  watercapacity: "Spray volume",
  bibulouscrouching: "Water absorbing scraper",
  suctionlevel: "Ventilation level",
  edgebrushpressure: "Edge brushing pressure",
  dustmop: "Dust push",
  detergentconcentration: "Cleaning agent concentration",
  cleaningmode: "Cleaning mode",
  snap: "Capture the moment",
  snaping: "Capturing in progress",
  snaped: "Image capture successful",
  serialnumber: "Serial number",
  operate: "operation",
  view: "see",
  intotal: "altogether",
  article: "strip",
  capturetime: "Capture time",
  supplying: "Supply in progress",
  autosupplying: "Automatic supply in progress",
  starttime: "start time",
  station: "workstation",
  supplymode: "Supply mode",
  fullsupply: "Full supply",
  chargeonly: "Only charging",
  initialization: "initialization",
  idle: "free",
  offline: "off-line",
  dormancy: "dormancy",
  crashstop: "Emergency stop",
  fault: "fault",
  mmode: "Manual mode",
  duringcleaning: "During cleaning operations",
  headingtodepot: "We are on our way to the supply station",
  headingtodockingstations: "Going to the docking point",
  remotecontrolready: "Remote control ready",
  remotecontroldriving: "Remote control driving",
  manualintervention: "manual intervention",
  shutdown: "Shutdown in progress",
  forcedlabor: "Forced labor",
  gotosupply: "Go to supply",
  gotodock: "Go to stop",
  customize: "Custom mode",
  deepcleaning: "Deep cleaning",
  dailycleaning: "Daily cleaning",
  silentcleaning: "Silent cleaning",
  rewashingmode: "Rewashing mode",
  energysavingmode: "Energy saving mode",
  dustpushmode: "Dust push mode",
  manualdrive: "Artificial driving",
  automaticsupply: "Automatic supply",
  enable: "Enable",
  disable: "Disable",
  vehiclerestartfailure: "Vehicle restart failed",
  determine: "determine",
  vehiclecannotrestart: "The vehicle cannot be restarted",
  continuetorestart: "Continue restarting",
  thereareunfinishedtasks:
    "There are unfinished tasks on the vehicle side. Do you want to continue executing them after restarting?",
  resumeafterrestart: "Continue after reboot",
  donotcontinueafterrestart: "Do not continue after reboot",
  login: "Sign in",
  customermanagement: "Venue management",
  customerlist: "Venue List",
  newcustomer: "New Venue",
  userlist: "User List",
  newusers: "New User",
  vehiclelist: "Vehicle List",
  relatedvehiclemanagement: "Related vehicle management",
  workstationmanagement: "Workstation Management",
  usermanage: "user management",
  resourcestatistics: "Resource statistics",
  vehiclemanagement: "Vehicle management",
  scheduledtasks: "Scheduled tasks",
  vehicleinformation: "Vehicle information",
  operater: "operate",
  datastatistics: "data statistics",
  singlecardatastatistics: "Bicycle data statistics",
  taskdetails: "Task Details",
  unattended: "Unmanned operation",
  unattendedcontrol: "Unmanned control",
  set: "set up",
  securitysetting: "security setting",
  pleaselogin: "Please log in",
  combinedtasks: "Combination task",
  multifloortasks: "Multi floor task",
  notstarted: "Not started yet",
  underexecution: "In progress",
  completed: "Completed",
  abnormalend: "Abnormal end",
  paused: "Pause in progress",
  proactivelyending: "Proactively end",
  edituser: "Edit User",
  username: "user name",
  inputusername: "enter one user name",
  tel: "cell-phone number",
  role: "role",
  loginpassword: "Login password",
  inputpassword: "Please input a password",
  confirmpassword: "Confirm password",
  car: "vehicle",
  cancellation: "cancel",
  submit: "Submit",
  enduser: "end user",
  repeataddvinhint: "The vehicle already exists, please do not add it again",
  passwordinputsinconsistent: "The two password inputs are inconsistent",
  edited: "Edited successfully",
  added: "Added successfully",
  resetting: "Resetting in progress",
  vehiclestatus: "Vehicle status",
  basicinformation: "Basic Information",
  vehiclemodel: "Vehicle model",
  vehiclearchitecture: "Vehicle architecture",
  vehiclename: "Vehicle name",
  modify: "modify",
  save: "preservation",
  registrationtime: "Registration time",
  simcardiccid: "SIM card ICCID",
  label: "label",
  adminpassword: "Admin password",
  reset: "Reset",
  userpassword: "User password",
  versioninformation: "Version information",
  softwareversion: "Software version",
  hardwareversion: "Hardware version",
  resetsuccessful: "Reset successful",
  timefiltering: "Time filtering",
  tasktype: "Task type",
  statisticaldatadownload: "Download statistical data",
  yes: "yes",
  deny: "no",
  details: "details",
  whole: "whole",
  minute: "minute",
  hour: "hour",
  taskname: "Task Name",
  cleaningfrequency: "Cleaning frequency",
  taskstarttime: "Task start time",
  taskendtime: "Task end time",
  cleaningtime: "Cleaning time",
  waterconsumption: "water consumption",
  electricityconsumption: "Electricity consumption",
  plannedcleaningaream2: "Planned cleaning area (㎡)",
  actualcleaningaream2: "Actual cleaning area (㎡)",
  uncleanedaream2: "Unclean area (㎡)",
  operator: "operator",
  export: "export",
  mapname: "Map Name",
  cleaningefficiencyh: "Cleaning efficiency",
  taskcompletionrate: "Task completion rate",
  supplyfrequency: "Supply frequency",
  endtime: "End time",
  combinationtaskname: "Combination task name",
  customername: "Venue name",
  onlineornot: "Is it online",
  online: "on-line",
  notonline: "Not online",
  vehiclevin: "Vehicle VIN",
  customerphotos: "Site photos",
  uploadimages: "Upload image",
  workstationmode: "Workstation mode",
  customeraddress: "Venue address",
  customerremarks: "Venue Remarks",
  exclusivestake: "Exclusive pile",
  sharedstake: "Shared pile",
  offlinepile: "Offline pile",
  customernamecannotbeemptyorblank: "The venue name cannot be empty or blank",
  customeraddresscannotbeemptyorblank:
    "The venue address cannot be empty or blank",
  thesizeoftheuploadedfilecannotexceed1mb:
    "The size of the uploaded file cannot exceed 1MB",
  theimagemustbeinjpgorpngformat: "The image must be in JPG or PNG format",
  inputonly: "Only input allowed",
  character: "Bit character",
  pleaseentercustomernamevehiclevinworkstationzin:
    "Please enter the venue name/vehicle VIN/workstation ZIN",
  search: "search",
  workstationzin: "Workstation ZIN",
  creationtime: "Creation time",
  founder: "Creator",
  supportvintagname: "Support VIN/tag name search",
  time: "time",
  rawdatadownload: "Raw data download",
  customer: "field",
  numberoftasks: "Number of tasks",
  tasktimeconsumption: "Task duration (min)",
  exitprompt: "Exit prompt",
  logout: "Do you want to log out?",
  wxb: "Woxiaobai Cloud Management Platform",
  pleaseenteraccountnumber: "Please enter your account",
  makecleaningeasy: "Snail Little White · Make Cleaning Simple",
  corporation: "Beijing Zhixing Technology Co., Ltd",
  notauserofthisplatform: "Non platform users",
  supportphonenamesearch: "Support phone number/name search",
  batchdelete: "Batch deletion",
  add: "add to",
  pleaseselct: "Please choose",
  domesticusers: "Domestic users",
  internationalusers: "International users",
  delete: "delete",
  resetpassword: "reset password",
  tips: "Tips",
  areyousure: "Are you sure",
  selecteddata: "Selected data",
  selectphonenumber: "Please select the user's phone number",
  savetime: "Saved successfully",
  pleasetryagain: "Save failed, please try again!",
  successfullydeleted: "Delete successfully",
  nouserselected: "No user selected",
  passwordresetto: "Password has been reset to",
  agent: "agent",
  userrole: "User Role",
  customertype: "customer type",
  usercomments: "User remarks",
  entermapname: "Please enter the scheduled task name/map name",
  repetitionperiod: "Repetitive cycle",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  forcedendtime: "Mandatory end time",
  expectedendtime: "Expected end time",
  timeconsuming: "time consuming",
  basicinformations: "Basic Information",
  inputtel: "Please enter your phone number",
  changepassword: "Change Password",
  originalpassword: "Original password",
  enteroriginalpassword: "Please enter the original password",
  newpassword: "New password",
  enternewpassword: "Please enter a new password",
  confirmnewpassword: "Confirm new password",
  enternewpasswordagain: "Please enter the new password again",
  successfullymodified: "Modified successfully",
  modificationfailed: "Modification failed",
  passwordissame: "The new password is the same as the original password",
  twicenotsame: "The passwords entered twice are not the same",
  supportvinsearch: "Support VIN search",
  onlinevehicles: "Online vehicles",
  faultyvehicle: "Faulty vehicle",
  presence: "Online state",
  faultstatus: "Fault status",
  entrycontrol: "Enter Control",
  wakeup: "awaken",
  awakening: "Awakening",
  confirmwanttowakevehicle: "Are you sure you want to wake up the vehicle?",
  wakeupsuccessfully: "Wake up successful",
  wakeupfailed: "Wake up failed, please try again",
  entryname: "entry name",
  clearwatervolume: "Clear water volume",
  sewagevolume: "Sewage volume",
  speeded: "speed",
  recentanomalies: "Recently abnormal",
  newuser: "New User",
  pleaseentervenueinformation: "Please enter venue information",
  language: "language",
  selectrole: "Please select a role",
  messageswitch: "Message switch",
  dutyhours: "Duty hours",
  remark: "remarks",
  incorrectformat: "The format of the phone number is incorrect",
  cannotbeempty: "The phone number cannot be empty",
  simplifiedchinese: "Simplified Chinese",
  english: "English",
  german: "German",
  fillinyournamecorrectly: "Please fill in your name correctly!",
  createdsuccessfully: "Created successfully",
  submittedsuccessfully: "Submitted successfully",
  enterphoneusername: "Please enter your phone number/username to search",
  state: "state",
  changesuccessful: "Change successful",
  changefailed: "Change failed",
  confirmdisable:
    "Please confirm to disable. After disabling this user, they will not be able to use mini programs and mobile apps. Are you sure you want to disable them?",
  mobilephone: "mobile phone",
  responsibleforthenumberofvehicles: "Responsible for the number of vehicles",
  supportusernamesearch: "Support username search",
  edit: "edit",
  deleteconfirmation: "Delete confirmation",
  deletedata: "Do you want to delete the selected data?",
  administrator: "Super administrator",
  admincannotbedeleted: "Cannot delete super administrator",
  lastlogintime: "Last login time",
  snaprecorde: "Capture Record",
  metre: "rice",
  changesleeptime: "Change sleep time",
  schedule: "speed of progress",
  supplymission: "Supply mission",
  returndockingpoint: "Return to the docking point",
  successfullyset: "Setting successful",
  settingfailed: "Setting failed",
  sleeptimeerrorhint:
    "It must be a pure number and the range must be between 900 seconds and 86400 seconds",
  supportvinvehiclenamecustomer:
    "Support searching for VIN, vehicle name, and venue name",
  vehicletype: "Vehicle type",
  novehicleselected: "No vehicle selected",
  switchdisplaymode: "Switch display mode",
  enterworkstationnumber: "Enter workstation device number",
  newworkstation: "Create a new workstation",
  enterdevicenumber: "Please enter the device number",
  inputenamehint: "Please enter a name",
  manualreset: "Manual reset",
  occupy: "occupy",
  notavailable: "Not available",
  equipmentnumber: "Equipment number",
  workstationname: "Workstation Name",
  adaptivevehiclemodel: "Suitable vehicle models",
  enableornot: "Is it enabled",
  workingmode: "Working mode",
  delayedrelease: "Delayed release",
  channel: "channel",
  on: "On",
  off: "Off",
  vehicles: "Vehicles",
  totalDevices: "Total Devices",
  onlineDevices: "Online Devices",
  cleaningArea: "Cleaning Area",
  operatingCleaningTime: "Operating Cleaning Time",
  operatingCleaningArea: "Operating Cleaning Area",
  days7: "7 Days",
  days30: "30 Days",
  days90: "90 Days",
  tasksuccesscount: "Task Success Count",
  taskabnormalcount: "Task Abnormal Count",
  taskTotalCount: "Task Total Count",
  faultstatistics: "Fault Statistics",
  powerconsumption: "Power Consumption",
  cleaningEfficiencyStatistics: "Cleaning Efficiency Statistics",
  maxCleaningEfficiency: "Maximum Cleaning Efficiency",
  cleaningEfficiency: "Cleaning Efficiency",
  taskEndNormal: "Normal End",
  taskEndAbnormal: "Abnormal End",
  taskEndPreparationFail: "Preparation Fail",
  taskEndSupply: "Supply",
  taskEndShutdown: "Shutdown",
  taskEndLocalizationFail: "Localization Fail",
  taskEndRescueTimeout: "Rescue Timeout",
  taskEndGlobalPathFail: "Global Path Fail",
  taskEndDispatchPathFail: "Dispatch Path Fail",
  taskEndNearGoalRescueFail: "Near Goal Rescue Fail",
  taskEndLowWaterSkip: "Low Water Skip",
  taskEndCrossFloorFail: "Cross Floor Fail",
  taskEndNodeFault: "Node Fault",
  taskEndPedalPressed: "Pedal Pressed",
  taskEndSewageAbnormal: "Sewage Abnormal",
  taskEndTargetUnreachable: "Target Unreachable",
  taskEndStartInVirtualWall: "Start In Virtual Wall",
  taskEndUnknown: "Unknown",
};
